class AdpPanelWithHeadingController {
  constructor() {
    this.name = 'adpPanelWithHeading';
  }
}

export default AdpPanelWithHeadingController;



// WEBPACK FOOTER //
// ./src/app/components/adpPanelWithHeading/adpPanelWithHeading.controller.js